<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-tag"></i> 客渠管理
                </el-breadcrumb-item>
				<el-breadcrumb-item>账期管理</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box">
				<el-input v-model="query.name" placeholder="名称" class="handle-input mr10"></el-input>
				<el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
            </div>
            <el-table
                :data="tableData"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
				:cell-style="{padding:4+'px'}"
				stripe
            >
				<el-table-column prop="name" label="名称"></el-table-column>
				<el-table-column prop="customerType" label="客户类型" :formatter="customerTypeFormat" width="100px"></el-table-column>
				<el-table-column prop="quality" label="客户质量" :formatter="qualityFormat" width="80px"></el-table-column>
				<el-table-column prop="valid" label="账期结算方式" width="150px">
					<template slot-scope="scope">
						{{scope.row.paymentMethod==0?"按固定天数结算":"按月周期结算"}}
					</template>
				</el-table-column>
				<el-table-column prop="cycle" label="账期周期" width="100px">
					<template slot-scope="scope">
						{{scope.row.cycle + (scope.row.paymentMethod==0?"天":"个月")}}
					</template>
				</el-table-column>
				<el-table-column prop="amount" label="账期额度" width="120px"></el-table-column>
				<el-table-column prop="valid" label="账期有效期" width="120px"></el-table-column>
				<el-table-column prop="trackName" label="跟踪人" width="120px"></el-table-column>
                <el-table-column label="操作" align="center" width="180px">
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            icon="el-icon-edit"
                            @click="handleEdit(scope.$index, scope.row)"
							v-if="controll['edit']"
                        >更新</el-button> &nbsp;
						<router-link  :to="{path:'/customer-period-record',query:{customer_id:scope.row.customerId}}" v-if="controll['customer-period-record']"><el-button
                            type="text"
                            icon="el-icon-edit-outline"
							v-if="controll['customer-period-record']"
                        >账期记录</el-button></router-link>
                    </template>
                </el-table-column>
            </el-table>
			<div class="record-a-d">
				<el-button
                    type="primary"
                    icon="el-icon-lx-add"
                    class="handle-del mr10"
                    @click="handleAdd"
					v-if="controll['add']"
                >添加记录</el-button>
			</div>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>

        <!-- 编辑弹出框 -->
        <el-dialog v-dialogDrag :close-on-click-modal=false :title="title" :visible.sync="editVisible" width="40%">
			<el-form ref="form" :model="form" label-width="120px" :rules="rules">
				<el-form-item label="客户名称" prop="customerId" v-if="!form.id">
					<el-select v-model="form.customerId" placeholder="请选择公司" filterable>
						<el-option key="" label="请选择公司" value=""></el-option>
						<el-option v-for="item in customersKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="客户名称" prop="name" v-if="form.id">
					{{form.name}}
				</el-form-item>
				<el-form-item label="付款结算方式" prop="paymentMethod">
					<el-select v-model="form.paymentMethod" placeholder="请选择付款结算方式" filterable>
						<el-option :key=0 label="按固定天数结算" :value=0></el-option>
						<el-option :key=1 label="按月周期结算" :value=1></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="账期周期" prop="cycle">
					<el-input-number v-model="form.cycle" :min="1" :max="periodDaysMax"></el-input-number>&nbsp;&nbsp;{{form.paymentMethod==0?"天":"个月"}}
				</el-form-item>
				<el-form-item label="账期额度" prop="amount">
					<el-input-number v-model="form.amount" :min="500" :max="periodAmountMax" :step="500"></el-input-number>&nbsp;&nbsp;元
				</el-form-item>
				<el-form-item label="对账日" prop="reconciliationDate" v-if="form.paymentMethod==1">
					<el-select v-model="form.reconciliationDate" placeholder="请选择对账日" filterable>
						<el-option key="" label="请选择对账日" value=""></el-option>
						<el-option v-for="item in dateKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="支付日" prop="paymentDate" v-if="form.paymentMethod==1">
					<el-select v-model="form.paymentDate" placeholder="请选择支付日" filterable>
						<el-option key="" label="请选择支付日" value=""></el-option>
						<el-option v-for="item in paymentDateKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="账期有效期" prop="valid">
					<el-date-picker
						type="date"
						placeholder="请选择账期有效期"
						v-model="form.valid"
						value-format="yyyy-MM-dd"
					></el-date-picker>
				</el-form-item>
				<el-form-item label="合同账期条款">
					<el-input type=textarea :rows=5 v-model="form.remark"> </el-input>
				</el-form-item>
			</el-form>
            
			<span slot="footer" class="dialog-footer">
				<el-button @click="editVisible = false">取 消</el-button>
				<el-button type="primary" @click="saveEdit" v-prevent-re-click>确 定</el-button>
			</span>
        </el-dialog>
    </div>
</template>

<script>
import { getControll } from '../../../utils/controlls';
import { fetchPeriodCustomerData, getEnumValueKV, updatePayPeriod, getNonPeriodCustomerKV, 
getCustomer, getApplyCompanyControlParam, getCustomerPeriodRecord } from '../../../api/index';
export default {
    name: 'customer-period',
    data() {
        return {
            query: {
                pageNum: 1,
                pageSize: 10
            },
			customersKV:[],
			customerTypeCode:1002,
			qualityCode:1010,
			customerTypeKV:[],
			qualityKV:[],
            tableData: [],
			editVisible: false,
            pageTotal: 0,
            form: {},
            idx: -1,
            id: -1,
			title:"",
			rules: {
                customerId: [{ required: true, message: '请选择需要赋予账期的公司', trigger: 'blur' }],
				paymentMethod: [{ required: true, message: '请选择付款结算方式', trigger: 'blur' }],
                cycle: [{ required: true, message: '账期周期不能为空', trigger: 'blur' }],
				amount: [{ required: true, message: '账期额度不能为空', trigger: 'blur' }],
				reconciliationDate: [{ required: true, message: '对账日期不能为空', trigger: 'blur' }],
				paymentDate: [{ required: true, message: '付款日期不能为空', trigger: 'blur' }],
				valid: [{ required: true, message: '请选择账期有效期', trigger: 'blur' }]
            },
			periodDaysMax:30,
			periodAmountMax:10000,
			controll:{},
			dateKV:[],
			paymentDateKV:[]
        };
    },
    created() {
		this.controll = getControll("customer-period");
		this.getDateKV();
		this.getcustomerTypeKV();
		this.getCustomerQualityKV();
		this.getCustomers();
		this.getControlParam();
        this.getData();
    },
    methods: {
		getDateKV() {
			for (var i = 1; i <= 31; i++) {
				this.dateKV.push({"key":i,"value":"每月" + i + "日"});
			}
			for (var i = 1; i <= 62; i++) {
				this.paymentDateKV.push({"key":i,"value":(i>31?"次":"当") + "月" + (i - (i>31?31:0)) + "日"});
			}
		},
		//获取渠道类型
		getcustomerTypeKV() {
			getEnumValueKV(this.customerTypeCode).then(res => {
				if (res.code == 0 ) {
					this.customerTypeKV = res.data;
				} else {
					this.$message.error("获取配置信息失败！" + res.message);
				}
			});
		},
		//获取渠道类型
		getCustomerQualityKV() {
			getEnumValueKV(this.qualityCode).then(res => {
				if (res.code == 0 ) {
					this.qualityKV = res.data;
				} else {
					this.$message.error("获取配置信息失败！" + res.message);
				}
			});
		},
		getControlParam() {
			getApplyCompanyControlParam().then(res => {
				if (res.code == 0 ) {
					this.periodDaysMax = res.data.periodDaysLimit;
					this.periodAmountMax = res.data.periodAmountLimit;
				} else {
					this.$message.error("获取控制信息失败！" + res.message);
				}
			})
		},
		//渠道类型格式化
		customerTypeFormat(row, column, cellValue) {
			for (var i = 0; i < this.customerTypeKV.length; i++) {
				if (this.customerTypeKV[i].key === cellValue){
					return this.customerTypeKV[i].value;
				}
			}
			return cellValue;
		},
		//渠道质量格式化
		qualityFormat(row, column, cellValue) {
			for (var i = 0; i < this.qualityKV.length; i++) {
				if (this.qualityKV[i].key === cellValue){
					return this.qualityKV[i].value;
				}
			}
			return cellValue;
		},
		accountPeriodFormat(row, column, cellValue) {
			if (typeof(cellValue) == "undefined") {
				return '否';
			} else {
				return Number(cellValue) == 0?'否':'是';
			}
		},
		//获取客户
		getCustomers() {
			getNonPeriodCustomerKV().then(res => {
				if (res.code == 0) {
					this.customersKV = res.data;
				} else {
					this.$message.error(`获取客户信息失败！` + res.message);
				}
			});
		},
        // 获取 easy-mock 的模拟数据
        getData() {
            fetchPeriodCustomerData(this.query).then(res => { 
				if (res.code == 0 ) {
					this.tableData = res.data.records;
					this.pageTotal = res.data.total;
				} else {
					this.$message.error("获取数据失败！" + res.message);
				}
            });
        },
        // 触发搜索按钮
        handleSearch() {
            this.$set(this.query, 'pageNum', 1);
			this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },
		//添加操作
		handleAdd() {
			this.form = {};
			this.$set(this.form, "paymentMethod", 0);
			this.title = "添加新账期";
			this.editVisible = true;
		},
        // 编辑操作
        handleEdit(index, row) {
            this.idx = index;
			this.form = {};
			this.title = "更新账期";
			getCustomerPeriodRecord(row.id).then(res => {
				if (res.code == 0) {
					this.form = res.data;
					this.$set(this.form, "name", row.name);
					this.$set(this.form, "customerId", row.customerId);
					this.editVisible = true;
				} else {
					this.$message.error(`获取数据详情失败！` + res.message);
				}
			})
        },
        // 保存编辑
        saveEdit() {
			updatePayPeriod(this.form).then(res => {
				if (res.code == 0) {
					this.$message.success('保存成功！');
					this.addVisible = false;
					this.editVisible = false;
					this.getData();
				} else {
					this.$message.error(`保存失败！` + res.message);
				}
			})
        },
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageNum', val);
			this.$set(this.query, 'pageIndex', val);
            this.getData();
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 180px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
.record-a-d {
	float:left; 
	padding-top:20px;
}
</style>
